import React, { useEffect, useState } from 'react';
import { Col, Form, FormInstance, Grid, Message, Row, Schema } from "rsuite";
import { UpsertCityDistrictAchievementType } from '@/models/achievement.model';
import { getCityDistrictsLookup } from '@/services/city-district.service';
import FetchingSelect from '@/components/FetchingSelect';

const modelSchema = Schema.Model<UpsertCityDistrictAchievementType>({
  districtId: Schema.Types.NumberType().isRequired('This field is required.'),
});
const emptyModel: UpsertCityDistrictAchievementType = {
  districtId: undefined,
};
export interface CityDistrictAchievementInitValue {
  districtId?: number,
};

interface CityDistrictVisitFormProps{
  formObject?: UpsertCityDistrictAchievementType;
  onFormChange: (formValue: any) => void;
  formRef?: React.Ref<FormInstance<Record<string, any>>>;
  loading: number;
  initValue?: CityDistrictAchievementInitValue;
}

const CityDistrictForm: React.FC<CityDistrictVisitFormProps> = ({ formObject, onFormChange, formRef, loading, initValue }) => {
  const [formValue, setFormValue] = useState<UpsertCityDistrictAchievementType>(emptyModel);
  
  useEffect(() => {
    if (formObject) {
      setFormValue(formObject);
    } else {
      setFormValue({...emptyModel, districtId: initValue?.districtId});
    }
  }, [formObject]);

  useEffect(() => {
    onFormChange(formValue);
  }, [formValue]);
  
  return (
    <Form name='upsert-first-country' fluid
        ref={formRef}
        formValue={formValue}
        model={modelSchema}
        disabled={!!loading}
    >    
      <Grid w='100%' fluid>
        <Row>
          <Col span={{xs:24, lg:6}} >
            <Form.Group controlId="districtId">
              <Form.Label>City District</Form.Label>
              <Form.Control name="districtId" accepter={FetchingSelect} block
                fetchData={(text, page) => getCityDistrictsLookup(text, page)} 
                placeholder="Select a District"
                value={formValue.districtId}
                onChange={val=> setFormValue(pre => ({...pre, districtId: val}))}
              />   
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <Message showIcon type="info">
            ...
          </Message>
        </Row>         
      </Grid>
    </Form>
  );
};

export default CityDistrictForm;